module.exports = __webpack_public_path__ + "2b13e0b554eb7de02993aa90eb9ef476.pdf";